import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'ifNull' })
export class IfNullPipe implements PipeTransform {

  transform(value: any, defaultValue: any): any {
    return value === null || value === undefined ? defaultValue : value
  }

}
